const userData = { avatar: '/assets/avatar.png' };

export default userData;
